import React from "react";
import PortfolioContainer from "./components/PortfolioContainer";
import Footer from './components/Footer'


const App = () => {
    return (
    <div>
        <PortfolioContainer /> <Footer />
     </div>

    )
}

export default App;